import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect, useRef, useState} from 'react';
import {BackHandler, Platform, View} from 'react-native';
import WebView from 'react-native-webview';
import {connect} from 'react-redux';

import {redirectRoutesAfterPayment} from '../../../../data/constants/paiement';
import {sendInfo} from '../../../../data/factory/paiement';
import {StackParams} from '../../../../data/types/navigation';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import {Loader} from '../../../components/Loader';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';

type NavigationProps = StackNavigationProp<StackParams, 'PaymentWebView'>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PaymentWebViewForm = (props: any) => {
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const {url, titleHeader, session} = props.route.params;
  const [IsLoading, setIsLoading] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [infoMessage] = useState('');

  const webViewRef = useRef<WebView | null>(null);

  const date = new Date();
  date.setTime(date.getTime() + 9000);
  const expires = date.toUTCString();

  const showErrorMessage = (message: string) => {
    setErrorMessage(message);
    setShowErrorModal(true);
  };

  const infoOkCompletion = () => {
    setShowInfoModal(false);
    sendInfo({
      ...props,
      okCompletion: redirectToHome,
      showError: showErrorMessage,
      setIsLoading: () => {
        setIsLoading(false);
      },
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const redirectToHome = (paramsSend: any) => {
    setIsLoading(false);
    const route = redirectRoutesAfterPayment[paramsSend.title];

    if (route) {
      navigate(route, {id: paramsSend.id});
    } else if (paramsSend.numeroPolice) {
      navigate('DetailContrat', paramsSend);
    } else {
      navigate('Home');
    }
  };

  useEffect(() => {
    BackHandler.addEventListener('hardwareBackPress', () => true);
    return () =>
      BackHandler.removeEventListener('hardwareBackPress', () => true);
  }, []);

  const cookieValue = `${session}:expires=${expires}domain=testsecureacceptance.cybersource.com:path=/;`;
  const setCookieScript = `
    // Définir le cookie avec la valeur spécifiée
    document.cookie = "${cookieValue}";
  `;

  return (
    <View style={{flex: 1, flexDirection: 'column'}}>
      <HeaderScreen title={titleHeader} type="retour" noBreadcrumb={false} />
      {IsLoading && <Loader />}
      {!IsLoading && Platform.OS !== 'ios' ? (
        <WebView
          style={{flex: 1}}
          source={{
            uri: url,
            headers: {
              Cookie: cookieValue,
            },
          }}
          onNavigationStateChange={navSate => {
            const {url} = navSate;

            if (url.includes('cancel') || url.includes('return')) {
              goBack();
            }

            if (url.includes('home')) {
              goBack();
            }
          }}
          automaticallyAdjustContentInsets={true}
          javaScriptEnabled={true}
          mixedContentMode={'always'}
          useWebkit={false}
          onMessage={() => {}}
          mediaPlaybackRequiresUserAction={true}
          allowFileAccess={true}
          scalesPageToFit={true}
          originWhitelist={['*']}
          domStorageEnabled={true}
          allowFileAccessFromFileURLs={true}
          allowsFullscreenVideo={true}
        />
      ) : (
        <WebView
          style={{flex: 1}}
          ref={webViewRef}
          source={{
            uri: url,
            headers: {
              Cookie: cookieValue,
            },
          }}
          injectedJavaScript={setCookieScript}
          javaScriptEnabled={true}
          originWhitelist={['*']}
          startInLoadingState={true}
          bounces={true}
          sharedCookiesEnabled
          onMessage={() => {}}
          automaticallyAdjustContentInsets={true}
          mediaPlaybackRequiresUserAction={true}
          allowFileAccess={true}
          scalesPageToFit={true}
          domStorageEnabled={true}
          allowFileAccessFromFileURLs={true}
          allowsFullscreenVideo={true}
          onNavigationStateChange={navSate => {
            const {url} = navSate;

            if (url.includes('cancel') || url.includes('return')) {
              goBack();
            }

            if (url.includes('home')) {
              goBack();
            }
          }}></WebView>
      )}

      {/** Error modal */}
      {showErrorModal && (
        <ConfirmationModal
          title="Erreur"
          content={errorMessage}
          btn1="OK"
          handleBtn1={() => {
            setShowErrorModal(false);
            goBack();
          }}
        />
      )}

      {/** Confirmation  modal */}
      {showInfoModal && (
        <ConfirmationModal
          title="Information"
          content={infoMessage}
          btn1="OK"
          handleBtn1={infoOkCompletion}
        />
      )}
    </View>
  );
};

export const PaymentWebView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentWebViewForm);
